import React, { useState, useEffect, useCallback } from "react";
import { RootRouteProps } from "router/types/stack";
import { useRoute } from "@react-navigation/native";

import { View } from "react-native";
import { Text, Toast, CodeInput } from "component";
import EntryScreensForm from "./EntryScreensForm";
import TimerSection from "./TimerSection";

import RNOtpVerify from "react-native-otp-verify";

import { strings, patterns } from "asset/constant";
import { css } from "style";
import { mq } from "utils";

import { useCart, useInsertMobile, useVerifyCode } from "client/api";
import { _goToHomeStack, _goToRegisterStack } from "router/helper";
import { Platform } from "react-native";
import { routeParamsAtom } from "store";
import { useRecoilValue } from "recoil";

export default function VerificationCode() {
  const routeParams = useRecoilValue(routeParamsAtom);

  const insertMobileMut = useInsertMobile();
  const verifyCodeMut = useVerifyCode();
  const { refetch: refetchCart, isFetching: cartIsFetching } = useCart();

  const [securityCode, setSecurityCode] = useState("");

  const _onSubmit = useCallback(() => {
    if (securityCode?.length < 5) {
      Toast.error({ message: strings?.fill_security_code });
      return;
    }

    if (!securityCode.match(patterns.number)) {
      Toast.error({ message: strings?.invalid_security_code });
      return;
    }

    const postData = { mobile: routeParams?.mobile, otp: securityCode };

    verifyCodeMut.mutate(postData, {
      onSuccess: (res) => {
        const data = res.data;
        if (data?.user) {
          refetchCart().then((response) => {
            if (response.status === "success") {
              _goToHomeStack();
            }
          });
        } else {
          _goToRegisterStack();
        }
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [securityCode, routeParams?.mobile]);

  const _onResendCode = () =>
    insertMobileMut.mutate({
      mobile: routeParams?.mobile,
      hash_code: routeParams?.hash_code,
    });

  useEffect(() => {
    if (Platform.OS === "android") {
      RNOtpVerify.startOtpListener((msg) => {
        setTimeout(
          () =>
            msg &&
            setSecurityCode(msg?.split("\n")?.[1]?.match(/\d+/g)?.[0] ?? ""),
          1000
        );
      });
    }

    return () => {
      if (Platform.OS === "android") {
        RNOtpVerify.removeListener();
      }
    };
  }, []);

  useEffect(() => {
    securityCode?.length === 5 &&
      securityCode.match(patterns.number) &&
      _onSubmit();
  }, [securityCode, _onSubmit]);

  return (
    <EntryScreensForm
      submit={_onSubmit}
      submitLabel={strings.confirm}
      submitLoading={verifyCodeMut?.isLoading || cartIsFetching}
    >
      <Text weight="bold" align="center">
        {strings.code_was_send_to(routeParams?.mobile ?? "")}
      </Text>
      <View
        style={{ width: mq(210), marginVertical: mq(30), ...css.selfCenter }}
      >
        <CodeInput code={securityCode} getValue={setSecurityCode} />
      </View>

      <TimerSection getCodeAgain={_onResendCode} />
      <View style={css.height(20)} />
    </EntryScreensForm>
  );
}
